<template>
  <div class="container">
    <div class="common-header-wrap">
      <mt-header title="我的钱包" class="common-header">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
      </mt-header>
    </div>
    <div class="div account_header">
      <div class="div predeposit ">
        <span class="predeposit_title">可用余额：</span><span class='available_predeposit'>{{ available_predeposit }}</span>
      </div>
      <div class="div amount-wrapper">
        <div class="div amount_item">充值卡余额 {{available_rc_balance}}</div>
        <div class="div amount_item">冻结金额 {{freeze_predeposit}}</div>
      </div>
    </div>
	<div class="div card-wrapper">
		<div class="div card_item" @click="$router.push({ name: 'MemberVoucherList', query: { index: 1 } })">
			<img class="img" src="../../../assets/image/member/icon_daijinquan_nor.png"></img>
			<div class="explain">代金券：{{voucher_count}}</div>
		</div>
		<div class="border"></div>
		<div class="div card_item" @click="$router.push({name:'MemberPointList'})">
			<img class="img" src="../../../assets/image/member/icon_jifen_nor.png"></img>
			<div class="explain">积分：{{points}}</div>
		</div>
	</div>
	<div class="div predeposit_handle mt-5">
	  <div class="div item" @click="$router.push({name:'MemberRechargeList'})"><img class="img" src="../../../assets/image/member/icon_chongzhi_pre.png" /><span>充值</span></div>
	  <div class="div item" @click="$router.push({name:'MemberWithdrawList'})"><img class="img" src="../../../assets/image/member/icon_tixian_pre.png" /><span>提现</span></div>
	</div>
	<div class="div account mt-5">
	  <div class="div menu">
		<div class="div" @click="$router.push({name:'MemberPredepositList'})"><flex-line class="menu-item" :is-link="true" :show-border="true"><span class="span line-name">资金明细</span></flex-line></div>
	    <div class="div" @click="$router.push({name:'MemberPointsOrderList'})"><flex-line class="menu-item" :is-link="true" :show-border="true"><span class="span line-name">积分兑换</span></flex-line></div>
	    <div class="div" @click="$router.push({name:'MemberBankList'})"><flex-line class="menu-item" :is-link="true" :show-border="true"><span class="span line-name">提现账户</span></flex-line></div>
	    <div class="div" @click="$router.push({name:'MemberRechargeCardList'})"><flex-line class="menu-item" :is-link="true" :show-border="true"><span class="span line-name">我的充值卡</span></flex-line></div>
	    <div class="div" @click="$router.push({name:'MemberBonusreceive'})"><flex-line class="menu-item" :is-link="true" :show-border="true"><span class="span line-name">红包领取记录</span></flex-line></div>
	  </div>
	</div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import { getMemberIndex } from '../../../api/member'
import { mapState } from 'vuex'
import flexLine from '../../flexLine'
export default {
  components: {
    flexLine
  },
  data () {
    return {
      available_predeposit: 0.00,
      freeze_predeposit: 0.00,
      voucher_count: 0,
      points: 0,
      available_rc_balance: 0
    }
  },
  created () {
    getMemberIndex().then(
      response => {
        if (response && response.result.member_info) {
          this.available_predeposit = response.result.member_info.available_predeposit
          this.freeze_predeposit = response.result.member_info.freeze_predeposit
          this.voucher_count = response.result.member_info.voucher_count
          this.points = response.result.member_info.member_points
          this.available_rc_balance = response.result.member_info.available_rc_balance
        }
      },
      error => {}
    )
  },
  computed: {

  },
  mounted () {

  },
  methods: {

  }
}
</script>
<style scoped lang="scss">
  .common-header-wrap .common-header{box-shadow: unset}
  .account_header{
    background: linear-gradient(360deg, #FB2732 0%, #FC5767 100%);
    color: #fff;
    padding: .7rem;
    font-size:$fontSize;
    box-sizing: border-box;
    .predeposit{
      padding: .5rem 0;
      margin-top:.8rem;
      display: flex;
  	  justify-content: center;
  	  align-items: center;
  	  .predeposit_title{
  		  font-size: 1rem;
  	  }
      .available_predeposit{
        font-size:1.5rem;
      }
  
    }
    .amount-wrapper{
      margin-top: 1.5rem;
      padding-top:.7rem;
      border-top:1px dashed rgba(255,255,255,.5);
      overflow: hidden;
      .amount_item{
        float: left;
        width: 50%;
      }
      .amount_item:nth-child(2){
        text-align: right;
      }
    }
  }
  .card-wrapper{
  	background-color: #fff;
  	display: flex;
  	padding: .5rem 0;
  	justify-content: center;
  	align-items: center;
  	.card_item{
  		width: 36%;
  		margin: 0 6%;
  		background-color: #F5A623;
  		padding: .8rem 0;
  		border-radius: .5rem;
  		text-align: center;
  		.img{
  			width: 1.5rem;
  			height: 1.5rem;
  		}
  		.explain{
  			font-size: $subFontSize;
  			color: #fff;
  		}
  	}
  	.card_item:nth-child(3){
  		background-color: #FF862F;
  	}
  	.border{
  		width: 1px;
  		background-color: #cdcdcd;
  		height: 2.8rem;
  	}
  }
  .predeposit_handle{
    height: 4rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
    background-color: #fff;
    .item{
      display: flex;
      justify-content: center;
      align-items: center;
  	  flex: 1;
      .img{
        width: 3rem;
        height: 3rem;
      }
  	  span{
  		font-size: .9rem;
  		color: #666;
  	  }
    }
  }
  .account{
    padding: 0 $pageSpace;
    background: #fff;
  
    .menu{
      background: #fff;
    }
  }
</style>
